import { Pipe, PipeTransform } from "@angular/core";
import * as _ from "lodash";

@Pipe({
  name: "findBy"
})
export class FindByPipe implements PipeTransform {
  transform(arr: any, path: string, value: any, type: any): any {
    if (!_.isArray(arr)) {
      return null;
    }
    if (_.isArray(value)) {
      return _.find(arr, item => _.includes(value, _.get(item, path)));
    } else {
      switch (type) {
        case ">":
          return _.find(arr, item => _.get(item, path) > value);
        case "<":
          return _.find(arr, item => _.get(item, path) < value);
        case "not":
          return _.find(arr, item => _.get(item, path) !== value);
        default:
          return _.find(arr, item => _.get(item, path) === value);
      }
    }
  }
}
